module.exports = __webpack_public_path__ + "static/media/sm.58dbae4c.jpg";